import s from './OwnerAsideNav.module.sass'

import React from 'react'

import { useAppDispatch } from '@app/model/store'

import { openCreateForm } from '@pages/OwnerPersonalPage/model/OwnerPostsModel/slice'

import IconOwnerHome from '@icons/icon-owner-home.svg'
import IconOwnerMegaphone from '@icons/icon-owner-megaphone.svg'
import IconOwnerRestaurant from '@icons/icon-owner-restaurant.svg'
import IconOwnerChatbubbles from '@icons/icon-owner-chatbubbles.svg'
import IconOwnerPlus from '@icons/icon-owner-plus.svg'
import IconOwnerGrowth from '@icons/icon-owner-growth.svg'
import IconOwnerRuble from '@icons/icon-owner-ruble-outline.svg'
import IconOwnerBooking from '@icons/icon-owner-booking-rest.svg'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

/**
 * @function getStatusText - TODO описание
 */
const getStatusText = (thisCount) => {
  // TODO: проверить склонение
  return 1 === parseInt(thisCount, 10) ? `${thisCount} новый` : `${thisCount} новых`
}

/**
 * @function OwnerAsideNav. stateless component
 * @description боковое меню личного кабинета ресторатора
 */
const OwnerAsideNav = ({ tabs, activeTab, handleActiveTab }) => {
  const isDevMode = useFeatureFlag('lkPromotion')
  const hasOwnerBooking = useFeatureFlag('ownerBooking')
  const { isTablet } = useClientResponsive()
  const dispatch = useAppDispatch()

  const handleClickOpenCreatePost = () => {
    dispatch(openCreateForm())
  }

  return (
    <ErrorBoundary>
      <aside className={s['container']}>
        {tabs.length > 0 && (
          <ul className={s['list-wrap']}>
            {tabs.map((thisTab, index) => {
              const isFirst = index === 0
              const isActive = thisTab.content === activeTab

              if (!isDevMode && thisTab.content === 'GrowthContent') return null
              if (!isDevMode && thisTab.content === 'RubleContent') return null
              if (!hasOwnerBooking && thisTab.content === 'BookingContent') return null

              return (
                <li
                  className={s['list-item']}
                  data-is-first={isFirst}
                  data-has-side-button={thisTab.has_side_button}
                  key={index}>
                  <button
                    className={s['item-action-button']}
                    data-with-status={thisTab.has_status}
                    data-selected={isActive}
                    onClick={(ev) => handleActiveTab(thisTab.content, ev)}
                    type='button'>
                    <>
                      {thisTab.icon === 'Home' && <IconOwnerHome className={s['icon']} />}
                      {thisTab.icon === 'Megaphone' && <IconOwnerMegaphone className={s['icon']} />}
                      {thisTab.icon === 'Restaurant' && <IconOwnerRestaurant className={s['icon']} />}
                      {thisTab.icon === 'Chatbubbles' && <IconOwnerChatbubbles className={s['icon']} />}
                      {thisTab.icon === 'Growth' && <IconOwnerGrowth className={s['icon']} />}
                      {thisTab.icon === 'Booking' && <IconOwnerBooking className={s['icon']} />}
                      {thisTab.icon === 'Ruble' && <IconOwnerRuble className={s['icon']} />}
                    </>

                    {isTablet && thisTab.short_label ? (
                      <span className={s['text']}>{thisTab.short_label}</span>
                    ) : (
                      thisTab.label && <span className={s['text']}>{thisTab.label}</span>
                    )}

                    {thisTab.content === 'BookingContent' && <span className={s['pro-badge']}>ПРО</span>}

                    {thisTab.has_status && thisTab.status_count > 0 && (
                      <span className={s['text-status']}>{getStatusText(thisTab.status_count)}</span>
                    )}
                  </button>

                  {thisTab.has_side_button && (
                    <button className={s['item-button-add-news']} type='button' onClick={handleClickOpenCreatePost}>
                      <IconOwnerPlus className={s['item-button-add-news-icon']} />
                    </button>
                  )}
                </li>
              )
            })}
          </ul>
        )}

        <p className={s['description']}>
          <span className={s['description-text']}>Связаться с нами: </span>
          <a className={s['description-mail-link']} href={'mailto:restaurants@afisha.ru'}>
            restaurants@afisha.ru
          </a>
        </p>
      </aside>
    </ErrorBoundary>
  )
}

export default OwnerAsideNav
